import { makeAutoObservable } from "mobx";
import { catalogsLoader } from "src/business/catalog/apiCatalog";
import { CatalogFilters, ZCatalog } from "src/business/catalog/ZCatalog";
import { RtStore } from "src/components/ReactiveTable/RtStore";

export const managCatalogsStore = makeAutoObservable({
  table: new RtStore<ZCatalog, CatalogFilters>({
    rowKey: "id",
    loader: catalogsLoader(),
  }),
});
